import MapClient from './MapClient';

export default MapClient;
